import { ApiTags, rootApi } from "../../../../services/rootApi";
import { ICourseHistory } from "./IProgramStructure";


const TAG = ApiTags.AcademicRegistration;

const getTags = (entities: ICourseHistory[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.courseHistoryId })),
  TAG,
];

const courseHistoryApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getProgramStructure: builder.query<ICourseHistory[], void>({
      query: () => "/CourseHistory",
      providesTags: (result) => (result ? getTags(result) : [TAG]),
    }),

    getCourseHistoryByStudentId: builder.query<ICourseHistory[], { studentId: string }>({
      query: ({ studentId }) => `/CourseHistory/(${studentId})`,
      providesTags: (result) => (result ? getTags(result) : [TAG]),
    }),
  }),
});

export const {
  useGetProgramStructureQuery,
  useGetCourseHistoryByStudentIdQuery,
  useLazyGetCourseHistoryByStudentIdQuery,
} = courseHistoryApi;
